import request from '../../utils/request';
import qs from 'qs'

export function getLoginUserInfo(authCode){
  return request({
    url: '/api/qywechat/qyLogin?' + 'authCode=' + authCode,
    method: 'get',
  })
}

export function analysisJWT(Authorization){
  return request({
    url: '/api/qywechat/analysisJWT',
    method: 'get',
    headers: {
      "authorization": Authorization
    }
  })
}

export function getTest(param){
  return request({
    url: 'api/qywechat/token/' + param ,
    method: 'get',
  })
}